module.exports = " <div class=\"item item-toggle von-toggle\" thin-border=\"\" _v-5623c656=\"\"> {{ text }} <label class=\"{{ toggleClass() }}\" @click=onToggle() _v-5623c656=\"\"> <input type=checkbox id=\"{{ toggleId }}\" _v-5623c656=\"\"> <div class=track _v-5623c656=\"\"> <div class=handle _v-5623c656=\"\"></div> </div> </label> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5623c656!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toggle/index.vue
// module id = 258
// module chunks = 0